import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-796c5d38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block" }
const _hoisted_2 = { class: "tile is-ancestor" }
const _hoisted_3 = { class: "tile is-parent is-vertical" }
const _hoisted_4 = { class: "tile is-child" }
const _hoisted_5 = { class: "card has-table has-mobile-sort-spaced" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "card-header-title" }, " Micro sitios ")
], -1))
const _hoisted_7 = { class: "card-content" }

import {onMounted, ref, computed} from "vue";
import MicroSites from "@/entities/micro-sites";
import MicroSiteImage from "@/components/admin/micro-sites/MicroSiteImage.vue";

interface Props {
  microSites: []
}

export default /*#__PURE__*/_defineComponent({
  props: {
    microSites: null
  },
  setup(__props: any) {

const props = __props as {
  microSites: []
}



const microSitesLocal = ref<Array<MicroSites>>();

const gridClass = computed(() => {
  if(props.microSites.length < 5){
    return 'grid-display-micro-sites-four-times';
  }else{
    return 'grid-display-micro-sites';
  }
})
onMounted(async () => {
  microSitesLocal.value = props.microSites
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: _normalizeClass(_unref(gridClass))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.microSites, (site) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: site.id
                  }, [
                    _createVNode(MicroSiteImage, {
                      description: site.description,
                      "img-u-r-l": site.micro_site_image.image.url,
                      url: site.url
                    }, null, 8, ["description", "img-u-r-l", "url"])
                  ]))
                }), 128))
              ], 2)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})